import axiosInstance from "./axiosInstance";

const MERCHANT_OPEN_API_BASE_URL = "/merchant/open-apis";

const merchantOpenApiService = {
  enableApi: async () => {
    const response = await axiosInstance.patch(
      `${MERCHANT_OPEN_API_BASE_URL}/enable`,
    );
    return response.data;
  },

  disableApi: async () => {
    const response = await axiosInstance.patch(
      `${MERCHANT_OPEN_API_BASE_URL}/disable`,
    );
    return response.data;
  },

  getOAuthClient: async () => {
    const response = await axiosInstance.get(
      `${MERCHANT_OPEN_API_BASE_URL}/oauth-client`,
    );
    return response.data;
  },

  createOAuthClient: async (data) => {
    const response = await axiosInstance.post(
      `${MERCHANT_OPEN_API_BASE_URL}/oauth-client`,
      data,
    );
    return response.data;
  },

  rotateOAuthClient: async (publicId) => {
    const response = await axiosInstance.patch(
      `${MERCHANT_OPEN_API_BASE_URL}/oauth-client/rotate-credentials/${publicId}`,
    );
    return response.data;
  },

  revokeOAuthClient: async (publicId) => {
    const response = await axiosInstance.patch(
      `${MERCHANT_OPEN_API_BASE_URL}/oauth-client/revoke-credentials/${publicId}`,
    );
    return response.data;
  },

  getCallbackUrl: async () => {
    const response = await axiosInstance.get(
      `${MERCHANT_OPEN_API_BASE_URL}/callback-url`,
    );
    return response.data;
  },

  saveCallbackUrl: async (data) => {
    const response = await axiosInstance.post(
      `${MERCHANT_OPEN_API_BASE_URL}/callback-url`,
      data,
    );
    return response.data;
  },
};

export default merchantOpenApiService;
